import { requestJira } from '@forge/bridge';

import { OptionWithUpdatedName, ParentOptionData } from '../components/config/interfaces';
import { IS_NOT_EMPTY } from '../utils/constants';

import { getJqlTextForMatchingOptionToDelete } from './utils';

export type IssuePickerSection = {
    label: string;
    id: string;
    msg: string;
    issues: IssuePickerIssue[] | [];
};

export type IssuePickerIssue = {
    id: string;
    key: string;
    keyHtml: string;
    img: string;
    summary: string;
    summaryText: string;
};

class IssueApi {
    getIssuesWithMatchingOptionValue(
        startAt: number,
        customFieldId: string,
        fieldName: string,
        levelToCheck: number,
        value: string | OptionWithUpdatedName[],
        levelParents: ParentOptionData[]
    ): Promise<Response> {
        const matchingOptionsJql = getJqlTextForMatchingOptionToDelete(levelParents, value as string, levelToCheck, fieldName);

        return requestJira(`/rest/api/3/search/jql?fields=*all&jql=cf[${customFieldId}] ${IS_NOT_EMPTY} ${matchingOptionsJql}`);
    }

    getAllIssuesWithJql(jql: string) {
        return requestJira(`/rest/api/3/search/jql?jql=${jql}&fields=*all`).then(res => res.json());
    }

    getIssuePickerSuggestions(query: string) {
        return requestJira(
            `/rest/api/3/issue/picker?query=${query}&showSubTasks=true&currentJQL=project%20IS%20NOT%20EMPTY`
        ).then(response => response.json());
    }

    updateIssue(body: string, issueIdOrKey: string) {
        return requestJira(`/rest/api/3/issue/${issueIdOrKey}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body,
        });
    }
}

export default new IssueApi();
